import React from 'react';
// import ContactForm from '../ContactForm';

export default function Contact() {
  return (
    <div>
      <h1>Contact Me</h1>
      <p id="contactme">
        Please send an email by <a href = "mailto:alexandria.l.guerrero@gmail.com">clicking here</a>
      </p>
      {/* < ContactForm /> */}
    </div>
  );
}
